import { globalRemoveMaskReal2 } from "../../../../../shared/utils";

export interface RawCoverage {
	id: string;
	name: string;
	coverageId?: string;
	factor?: number;
	limite_min?: string;
	limite_max?: string;
	rate_increase?: string;
	status?: string;
	value?: string;
	enabled?: boolean;
}

interface CalculateCoveragesParams {
	coverages: RawCoverage[];
	rentValue?: string;
	quotationId?: string;
}

export const calculateCoveragesValues = ({ coverages, rentValue, quotationId }: CalculateCoveragesParams): RawCoverage[] => {
	if (!coverages || !coverages.length) return [];

	const rent = Number(globalRemoveMaskReal2(rentValue ?? "0"));
	const isNewQuotation = quotationId === "novo";

	return coverages.map((c, idx) => {
		const factor = Number(c.factor ?? 1);
		const limiteMin = Number(c.limite_min ?? 0);
		const limiteMax = Number(c.limite_max ?? 0);

		let calculatedValue = limiteMin;

		// 🔹 Nova cotação → calcula com base no aluguel e fator
		if (isNewQuotation && rent > 0 && factor > 0) {
			calculatedValue = rent * factor;

			// 🔒 Garante que o valor fique dentro dos limites permitidos
			if (limiteMin && calculatedValue < limiteMin) calculatedValue = limiteMin;
			if (limiteMax && calculatedValue > limiteMax) calculatedValue = limiteMax;
		}

		// 💰 Formata o valor final igual ao card
		const formattedValue = calculatedValue.toLocaleString("pt-BR", {
			style: "currency",
			currency: "BRL",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});

		return {
			id: c.id ?? String(idx),
			name: c.name,
			coverageId: c.coverageId,
			factor,
			limite_min: c.limite_min,
			limite_max: c.limite_max,
			rate_increase: c.rate_increase,
			status: c.status,
			enabled: true,
			value: formattedValue, // ✅ valor já formatado
		};
	});
};
